import { render, staticRenderFns } from "./RecipeEdit.vue?vue&type=template&id=470c846c"
import script from "./RecipeEdit.vue?vue&type=script&lang=js"
export * from "./RecipeEdit.vue?vue&type=script&lang=js"
import style0 from "./RecipeEdit.vue?vue&type=style&index=0&id=470c846c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports